// src/components/Propuestas/CrearPropuesta.js
import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Card, Row, Col, Table, Alert, Spinner, Badge, ListGroup } from 'react-bootstrap';
import { useAuth } from '../../hooks/useAuth'
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import {
  crearPropuesta,
  actualizarPropuesta,
  getDataobtener,
  filterData,
  getDataList,
  postDataClientes,
  crearDatos,
  getDataObtenerUno,
  actualizarDatos,
  obtenerPlantillaActiva,
  getItemsContable,
  getActiveProvider,
  obtenerPlantillaUnica,
  reservarIdPropuesta,
  subirArchivoPropuesta
} from '../../api/common';
import { EditarItem } from '../Items/EditarItem';
import ClienteModal from '../Clientes/ClienteModal';
import extraerNombreArchivo from './extraerNombreArchivoFirebase';
import ItemSearchSelect from '../../utils/ItemSearchSelect';
import ClientSearchSelect from '../../utils/ClientSearchSelect';
import './Propuestas.css';

const CrearPropuesta = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const esEdicion = !!id;
  const {userData}=useAuth()

  const [loading, setLoading] = useState(false);
  const [loadingInicial, setLoadingInicial] = useState(true);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });
  const [motivoCambio, setMotivoCambio] = useState('');
  const [errorMotivo, setErrorMotivo] = useState('');
  const [taxes, setTaxes] = useState([]);

  // Tipo de edición (solo aplica en /propuestas/editar/:id)
  const [tipoEdicion, setTipoEdicion] = useState('cliente');
  const [evidenciaCambio, setEvidenciaCambio] = useState('');
  const [subiendoEvidenciaCambio, setSubiendoEvidenciaCambio] = useState(false);



  // Proveedor contable activo
  const [proveedorActivo, setProveedorActivo] = useState(null); // null = cargando, false = sin proveedor, objeto = proveedor
  // Modal sincronizar ítem desde propuesta
  const [modalSyncItem, setModalSyncItem] = useState({ show: false, item: null });
  // Modal sincronizar cliente desde propuesta
  const [modalSyncCliente, setModalSyncCliente] = useState({ show: false, cliente: null });
  const [clienteSeleccionadoData, setClienteSeleccionadoData] = useState(null);

  // Origen de solicitud (ISO 17025 trazabilidad)
  const [origenSolicitud, setOrigenSolicitud] = useState({ origen: '', evidenciaFile: '' });
  const [subiendoEvidencia, setSubiendoEvidencia] = useState(false);

  // ID reservado para la propuesta nueva (necesario para subir la primera evidencia
  // ANTES de que la propuesta exista en BD). El estado garantiza re-render para el body
  // del crear; el ref evita una race condition en doble click sobre el input file.
  const [propuestaIdReservado, setPropuestaIdReservado] = useState(null);
  const propuestaIdReservadoRef = useRef(null);

  // Lazy: solo reserva un _id la primera vez que se necesita (al subir evidencia o submit)
  const asegurarIdReservado = async () => {
    if (propuestaIdReservadoRef.current) return propuestaIdReservadoRef.current;
    const res = await reservarIdPropuesta();
    const nuevoId = res.data?._id;
    if (!nuevoId) throw new Error('No se pudo reservar id de propuesta');
    propuestaIdReservadoRef.current = nuevoId;
    setPropuestaIdReservado(nuevoId);
    return nuevoId;
  };

  // Datos del formulario
  const [formData, setFormData] = useState({
    cliente_id: null,
    clienteIdContable: '',
    fecha_propuesta: moment().format('YYYY-MM-DD'),
    fecha_vigencia: moment().add(30, 'days').format('YYYY-MM-DD'),
    condiciones_pago: '50% anticipo y 50% al finalizar',
    observaciones: '',

    creado_por:userData._id
  });


  console.log('formData actual:', formData);
  // Descuento global (%) — se aplica a todos los ítems al cambiarlo
  const [descuentoGlobal, setDescuentoGlobal] = useState(0);


  // Opción actualmente seleccionada en el selector de clientes (async)
  const [clienteOption, setClienteOption] = useState(null);
  // Listas para selects
  const [itemsDisponibles, setItemsDisponibles] = useState([]);
  const [avisoClienteSync, setAvisoClienteSync] = useState('');

  // Ítems de la propuesta - SIEMPRE empieza con 1 fila vacía
  const [itemsPropuesta, setItemsPropuesta] = useState([crearFilaVacia()]);
 
  console.log('itemsPropuesta actual:', itemsPropuesta);

  // Solicitudes de cambio del cliente: mapa { [item_id_string]: solicitud }
  const [solicitudesPorItemId, setSolicitudesPorItemId] = useState({});
  // IDs de items cuya solicitud el usuario ya atendió localmente
  const [solicitudesAtendidas, setSolicitudesAtendidas] = useState(new Set());

  useEffect(() => {
    cargarDatosIniciales();

  }, []);


  useEffect(() => {
    if (esEdicion && id) {
      cargarPropuesta();
    }
  }, [id]);

  // Crear fila vacía
  function crearFilaVacia() {
    return {
      id_temporal: Date.now() + Math.random(), // ID único para React keys
      item_id: null,
      codigo: '',
      nombre: '',
      descripcion: '',
      cantidad: 1,
      valor_unitario: 0,
      taxDescuento: 0,
      porcentaje_iva: 19,
      subtotal: 0,
      valor_iva: 0,
      total: 0
    };
  }

  const cargarDatosIniciales = async () => {
    try {
      // Verificar proveedor contable activo
      try {
        const provRes = await getActiveProvider();
        const taxesRes = await getDataList('Taxes');
        if (taxesRes.status === 200 && Array.isArray(taxesRes.data.data)) {
          setTaxes(taxesRes.data.data);
        } else {  
          // se abre un modal         
          console.warn('No se pudieron cargar los impuestos contables');
        }
        const proveedores = provRes?.data?.data;
        const activo = Array.isArray(proveedores) ? proveedores.find(p => p.active) : null;
        setProveedorActivo(activo || false);
      } catch {
        setProveedorActivo(false);
      }
      // Cargar plantilla activa para defaults (solo en creación)
      if (!esEdicion) {
        try {
          const plantillaRes = await obtenerPlantillaUnica();
          if (plantillaRes.status === 200 && plantillaRes.data?.data) {
            const p = plantillaRes.data.data;

            setFormData(prev => ({
              ...prev,
               snashopPlantilla: {
                    titulo: p.titulo || '',
                    version: p.versionactual || 1,
                    codigo: p.codigo || '',
                    mensaje_inicial: p.mensaje_inicial || '',
                  },
              condiciones_pago: p.condiciones_pago || prev.condiciones_pago,
              observaciones: p.observaciones || prev.observaciones,
              descuento_global: p.descuento_global ?? prev.descuento_global,
              descuento_global_tipo: p.descuento_global_tipo || prev.descuento_global_tipo,
              fecha_vigencia: moment().add(p.dias_vigencia || 30, 'days').format('YYYY-MM-DD'),
              fileDownload: p.fileAdj || []

            }));
            if (p.descuento_global > 0) setDescuentoGlobal(p.descuento_global);
          } else {
            setMensaje({
              tipo: 'warning',
              texto: 'No se pudo cargar la plantilla activa. La propuesta quedará sin encabezado ni mensaje inicial. Recargue la página antes de continuar.'
            });
          }
        } catch (e) {
          console.error('Error al cargar plantilla activa:', e);
          setMensaje({
            tipo: 'warning',
            texto: 'Error al cargar la plantilla activa. La propuesta quedará sin encabezado ni mensaje inicial. Recargue la página antes de continuar.'
          });
        }
      }

      // Cargar items/productos disponibles
      const itemsRes = await getDataList('Items');
      
      if (itemsRes.status==200 && itemsRes.data.data) {
        const itemsFormateados = itemsRes.data.data.map(i => ({
          value: i._id,
          label: `${i.nombre}`,
          codigo: 2512,
          itemIdContable: i.contabilidad?.id || '',
          data: i
        }));
        setItemsDisponibles(itemsFormateados);
      }
    } catch (error) {
      console.error('Error al cargar datos iniciales:', error);
      setMensaje({ tipo: 'danger', texto: 'Error al cargar datos iniciales' });
    } finally {
      // En edición, cargarPropuesta() es el dueño de loadingInicial
      if (!esEdicion) setLoadingInicial(false);
    }
  };

  // Cargar propuesta a editar y mapear a estado local
  const cargarPropuesta = async () => { 
    setLoadingInicial(true);
    try {
      const response = await getDataObtenerUno('Propuestas', {_id:id});
      
      if (response.status==200 && response.data.data) {
        const prop = response.data.data;
        
        setFormData({

          sincronizada: prop.sincronizada || false,
          clienteIdContable: prop.clienteIdContable || '',
          cliente_id: prop.cliente_id._id,
          fecha_propuesta: moment.utc(prop.fecha_propuesta).format('YYYY-MM-DD'),
          fecha_vigencia: moment.utc(prop.fecha_vigencia).format('YYYY-MM-DD'),
          condiciones_pago: prop.condiciones_pago,
          observaciones: prop.observaciones,
          estado: prop.estado,
        });

        // Si la propuesta no está en borrador, solo se permite edición solicitada por el cliente
        if (prop.estado !== 'borrador') {
          setTipoEdicion('cliente');
        }

        setOrigenSolicitud({
          origen: prop.origenSolicitud.origen || '',
          evidenciaFile: prop.origenSolicitud.evidenciaFile || ''
        });
        
        // Cargar ítems + agregar 1 fila vacía al final
        // item_id puede venir como objeto populado { _id, codigo, nombre } desde el backend
        const itemsCargados = prop.items.map(item => ({
          id_temporal: Date.now() + Math.random(),
          ...item,
          item_id: item.item_id?._id ? String(item.item_id._id) : item.item_id
        }));
        setItemsPropuesta([...itemsCargados, crearFilaVacia()]);

        // Construir mapa solicitudes por item_id para que sea estable al reordenar/eliminar
        const solicMap = {};
        (prop.solicitudes_cambio || []).forEach(s => {
          const itemRef = prop.items[s.item_index];
          if (itemRef) {
            const itemId = String(itemRef.item_id?._id || itemRef.item_id || '');
            if (itemId) solicMap[itemId] = s;
          }
        });
        setSolicitudesPorItemId(solicMap);
        setSolicitudesAtendidas(new Set());

        // Reconstruir opción del cliente para el selector async
        const clienteData = prop.cliente_id;
        if (clienteData?._id) {
          const partes = [clienteData.nombre];
          if (clienteData.identificacion) partes.push(clienteData.identificacion);
          if (clienteData.ciudad) partes.push(clienteData.ciudad);
          const option = { value: clienteData._id, label: partes.join(' · '), data: clienteData };
          setClienteOption(option);
          setClienteSeleccionadoData(clienteData);
        }
      }
    } catch (error) {
      console.error('Error al cargar propuesta:', error);
      setMensaje({ tipo: 'danger', texto: 'Error al cargar propuesta' });
    } finally {
      setLoadingInicial(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const itemEstaSincronizado = (itemId) => {
    // Si no hay proveedor cargado aún o no existe → no sincronizado
    if (!proveedorActivo) return false;
    if (!itemId) return false;

    const found = itemsDisponibles.find(opt => String(opt.value) === String(itemId));
    if (!found) return false;

    const contab = found.data?.contabilidad;
    return !!(contab?.providerId &&
      contab.providerId === String(proveedorActivo._id) &&
      contab.id);
  };


  /** Aplica un porcentaje de descuento (0-100) a todos los ítems con producto seleccionado */
  const handleCambiarDescuentoGlobal = (valor) => {
    const pct = Math.min(100, Math.max(0, parseFloat(valor) || 0));
    setDescuentoGlobal(pct);
    setItemsPropuesta(prev => prev.map(item => {
      if (!item.item_id) return item;
      return calcularTotalesItem({ ...item, taxDescuento: pct });
    }));
  };

  const handleClienteChange = (selectedOption) => {
    setClienteOption(selectedOption);
    setFormData({ ...formData, cliente_id: selectedOption?.value || null });
    setClienteSeleccionadoData(selectedOption?.data || null);
    // Validar si el cliente tiene contabilidad sincronizada con el proveedor activo

    if (selectedOption && proveedorActivo && proveedorActivo._id) {

      const c = selectedOption.data?.contabilidad;
      if (!c || !c.providerId || !c.id) { // no tiene sync contable
        setAvisoClienteSync('no_sync');
      } else if (String(c.providerId) !== String(proveedorActivo._id)) {  // tiene sync pero con otro proveedor diferente al activo

        setAvisoClienteSync('otro_proveedor');
      } else {  // tiene sync con el proveedor activo, todo bien se debe actualizar la información del cliente en la propuesta con los datos del proveedor contable para que luego se pueda sincronizar correctamente la propuesta con el proveedor contable en formdata y en el estado clienteSeleccionadoData, y se limpia cualquier aviso de sync que hubiera
        
        const updatedClienteData = { ...selectedOption.data, contabilidad: c };
        setClienteSeleccionadoData(updatedClienteData);
        setFormData({ ...formData, 
          cliente_id: updatedClienteData._id,
          clienteIdContable: c.id || ''
        });
        setAvisoClienteSync('');
      }
    } else {
      setAvisoClienteSync('');
    }
  };

  const handleSaveCliente = async (formDataCliente) => {
    const clienteId = clienteSeleccionadoData?._id;
    if (!clienteId) return;
    try {
      await actualizarDatos('Usuarios', formDataCliente, clienteId);
      // Recargar solo el cliente actualizado para re-evaluar sINCRONIZADO
      const clienteRes = await getDataObtenerUno('Usuarios', { _id: clienteId });

      if (clienteRes.status === 200 && clienteRes.data.data) {
        const c = clienteRes.data.data;
        const partes = [c.nombre];
        if (c.identificacion) partes.push(c.identificacion);
        if (c.ciudad) partes.push(c.ciudad);
        const opcionActualizada = { value: c._id, label: partes.join(' · '), data: c };
        handleClienteChange(opcionActualizada);
      }

      setModalSyncCliente({ show: false, cliente: null });
    } catch (err) {
      console.error('Error al actualizar cliente:', err);
    }
  };

  // ==================== MANEJO DE ÍTEMS ====================

  const handleItemSelect = (index, selectedOption) => {
    if (!selectedOption) {
      // Limpiar la fila si deselecciona
      handleCambiarCampoItem(index, 'item_id', null);
      handleCambiarCampoItem(index, 'codigo', '');
      handleCambiarCampoItem(index, 'nombre', '');
      handleCambiarCampoItem(index, 'descripcion', '');
      handleCambiarCampoItem(index, 'valor_unitario', 0);
      handleCambiarCampoItem(index, 'taxDescuento', 0);
      handleCambiarCampoItem(index, 'itemIdContable', '');
      handleCambiarCampoItem(index, 'idIvaContable', 0);
      return;
    }

    const itemData = selectedOption.data;

    // Validar si el producto ya está en la lista
    const yaExiste = itemsPropuesta.some(
      (item, idx) => idx !== index && item.item_id === itemData._id
    );

    if (yaExiste) {
      alert('Este producto ya está agregado en la propuesta. No se permiten duplicados.');
      return;
    }

    // Autocompletar campos — si hay proveedor activo y el ítem tiene contabilidad del mismo provider,
    // usar precio y nombre del proveedor contable si están disponibles
    const contab = itemData.contabilidad;
    const sincronizado = itemEstaSincronizado(itemData._id);
    const precioFinal = (sincronizado && contab?.priceLists?.[0]?.price)
      ? contab.priceLists[0].price
      : itemData.precio || 0;
    const nombreFinal = (sincronizado && contab?.name) ? contab.name : itemData.nombre;
    const descFinal = (sincronizado && contab?.description) ? contab.description : (itemData.descripcion || '');
    const nuevosItems = [...itemsPropuesta];

    nuevosItems[index] = {
      ...nuevosItems[index],
      item_id: itemData._id,
      itemIdContable: itemData.contabilidad?.id || '',
      idIvaContable: itemData.contabilidad?.taxes?.[0]?.id || 0,
      _itemData: itemData,         // ref completa para poder abrir modal de sync
      codigo: itemData.codigo,
      nombre: nombreFinal,
      taxDescuento: 0,
      descripcion: descFinal,
      valor_unitario: precioFinal,
      porcentaje_iva: itemData.iva || 19
    };

    // Recalcular totales del ítem
    nuevosItems[index] = calcularTotalesItem(nuevosItems[index]);

    setItemsPropuesta(nuevosItems);

    // Agregar nueva fila vacía si es la última fila y tiene producto seleccionado
    if (index === itemsPropuesta.length - 1) {
      setItemsPropuesta([...nuevosItems, crearFilaVacia()]);
    }
  };

    const handleCambiarCampoItem = (index, campo, valor) => {
    const nuevosItems = [...itemsPropuesta];
    

    // Si es valor_unitario, limpiar el formato de moneda antes de guardar
    if (campo === 'valor_unitario') {
        nuevosItems[index][campo] = limpiarMoneda(valor);
    } else if (campo === 'taxDescuento') {
        nuevosItems[index][campo] = Math.min(100, Math.max(0, parseFloat(valor) || 0));
    } else {
        nuevosItems[index][campo] = valor;
    }

    // Recalcular si cambió cantidad, valor_unitario, porcentaje_iva o taxDescuento
    if (['cantidad', 'valor_unitario', 'porcentaje_iva', 'taxDescuento'].includes(campo)) {
        nuevosItems[index] = calcularTotalesItem(nuevosItems[index]);
    }

    console.log('nuevos items después de cambio:', nuevosItems);
    setItemsPropuesta(nuevosItems);
    };

  const calcularTotalesItem = (item) => {
    const cantidad      = parseFloat(item.cantidad) || 0;
    const valorUnitario = parseFloat(item.valor_unitario) || 0;
    const porcentajeIva = parseFloat(item.porcentaje_iva) || 0;
    const descuento     = Math.min(100, Math.max(0, parseFloat(item.taxDescuento) || 0));

    // subtotal = precio descontado * cantidad (base imponible de este ítem)
    const subtotal  = Math.round(cantidad * valorUnitario * (1 - descuento / 100) * 100) / 100;
    const valorIva  = Math.round(subtotal * porcentajeIva / 100 * 100) / 100;
    const total     = Math.round((subtotal + valorIva) * 100) / 100;

    return {
      ...item,
      taxDescuento: descuento,
      subtotal,
      valor_iva: valorIva,
      total
    };
  };

  const handleEliminarItem = (index) => {
    // No permitir eliminar si solo hay 1 fila (la vacía)
    if (itemsPropuesta.length === 1) {
      setItemsPropuesta([crearFilaVacia()]);
      return;
    }

    const nuevosItems = itemsPropuesta.filter((_, i) => i !== index);
    
    // Asegurar que siempre haya al menos 1 fila vacía al final
    const ultimaFila = nuevosItems[nuevosItems.length - 1];
    if (ultimaFila && ultimaFila.item_id !== null) {
      nuevosItems.push(crearFilaVacia());
    }

    setItemsPropuesta(nuevosItems);
  };

  // ==================== CÁLCULOS TOTALES ====================

  const calcularTotalesGenerales = () => {
    const itemsValidos = itemsPropuesta.filter(item => item.item_id !== null);

    // total_bruto = suma de cantidad * valor_unitario original (sin descuento)
    const total_bruto = Math.round(
      itemsValidos.reduce((sum, item) =>
        sum + (parseFloat(item.cantidad) || 0) * (parseFloat(item.valor_unitario) || 0), 0
      ) * 100
    ) / 100;

    // subtotal = suma de subtotales ya descontados por ítem
    const subtotal = Math.round(
      itemsValidos.reduce((sum, item) => sum + item.subtotal, 0) * 100
    ) / 100;

    const total_iva = Math.round(
      itemsValidos.reduce((sum, item) => sum + item.valor_iva, 0) * 100
    ) / 100;

    const total_pagar = Math.round((subtotal + total_iva) * 100) / 100;

    return { total_bruto, subtotal, total_iva, total_pagar, cantidad_items: itemsValidos.length };
  };

    // recibe el tax seleccionado y cambia el campo porcentaje_iva, idIvaContable de la lista de nuevos itemsPropuesta en el index correspondiente al item que se está editando, y además agrega el tax seleccionado al array de tax del item en el formData, para que se guarde esa información en la propuesta. El tax seleccionado viene con la información del proveedor contable, por lo que al agregarlo al item de la propuesta también se está relacionando ese ítem con el concepto de impuesto del proveedor contable, lo que permitirá luego sincronizar correctamente esa información con el sistema contable externo al momento de crear o actualizar la propuesta.
  const handleSeleccionarTax = (index, tax) => {


    const nuevosItems = [...itemsPropuesta];
    nuevosItems[index].porcentaje_iva = tax.porcentaje;
    nuevosItems[index].idIvaContable = tax.idContable || '';
    nuevosItems[index].tax = tax; // Agregar el tax seleccionado al array de tax del item

    // Recalcular totales del ítem
    nuevosItems[index] = calcularTotalesItem(nuevosItems[index]);

    setItemsPropuesta(nuevosItems);

  }

  // ==================== VALIDACIÓN Y ENVÍO ====================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.cliente_id || !clienteSeleccionadoData) {  
      setMensaje({ tipo: 'danger', texto: 'Debe seleccionar un cliente' });
      return;
    }

    if (['Redes sociales', 'Email'].includes(origenSolicitud.origen) && !origenSolicitud.evidenciaFile) {
      setMensaje({ tipo: 'danger', texto: 'Debe adjuntar evidencia para el origen seleccionado' });
      return;
    }

    // Filtrar solo ítems válidos (con producto seleccionado)
    const itemsValidos = itemsPropuesta.filter(item => item.item_id !== null);

    if (itemsValidos.length === 0) {
      setMensaje({ tipo: 'danger', texto: 'Debe agregar al menos un ítem a la propuesta' });
      return;
    }

    // Validar cantidades
    const hayItemsInvalidos = itemsValidos.some(item => 
      !item.cantidad || item.cantidad <= 0 || !item.valor_unitario || item.valor_unitario < 0
    );

    if (hayItemsInvalidos) {
      setMensaje({ tipo: 'danger', texto: 'Todos los ítems deben tener cantidad y valor unitario válidos' });
      return;
    }

    setLoading(true);
    setMensaje({ tipo: '', texto: '' });

    if (esEdicion) {
      if (!motivoCambio.trim()) {
        setErrorMotivo('El motivo del cambio es obligatorio');
        setLoading(false);
        return;
      }
      if (tipoEdicion === 'cliente' && !evidenciaCambio) {
        setMensaje({ tipo: 'danger', texto: 'Debe adjuntar evidencia para edición solicitada por el cliente' });
        setLoading(false);
        return;
      }
      if (tipoEdicion === 'interna' && formData.estado !== 'borrador') {
        setMensaje({ tipo: 'danger', texto: 'Solo se permite edición interna si la propuesta está en borrador' });
        setLoading(false);
        return;
      }
      setErrorMotivo('');
    }

    const totales = calcularTotalesGenerales();
    const clienteData = clienteSeleccionadoData;

    console.log('cliente seleccionado para envío:', clienteData);
    // Limpiar id_temporal y _itemData (referencias internas) de los ítems antes de enviar
    const itemsLimpios = itemsValidos.map(({ id_temporal, _itemData, ...item }) => item);

    const dataToSend = {
      ...formData,
      cliente_nombre: clienteData.nombre,
      cliente_nit: clienteData.identificacion,
      cliente_email: clienteData.correo,
      cliente_telefono: clienteData.telefono,
      cliente_direccion: clienteData.direccion,
      cliente_ciudad: clienteData.ciudad,
      clienteIdContable: clienteData.contabilidad?.id || '',
      items: itemsLimpios,
      ...totales,
      ...(origenSolicitud.origen ? { origenSolicitud } : {})
    };

    try {
      let response;
      if (esEdicion) {
        response = await actualizarDatos('Propuestas', {
          ...dataToSend,
          motivo_cambio: motivoCambio,
          tipo_edicion: tipoEdicion,
          evidencia_cambio: evidenciaCambio
        }, id);
      } else {
        // Si ya se reservo un _id (porque se subio la primera evidencia antes
        // del submit), enviarlo en el body para que la propuesta se cree con ese ID
        // y los archivos ya subidos a `propuestas/{idReservado}/origen/` queden
        // efectivamente asociados al documento. Si no hay reserva, el backend
        // genera el _id automaticamente (retro-compatible).
        const idParaCrear = propuestaIdReservadoRef.current;
        response = await crearDatos('Propuestas', {
          ...dataToSend,
          ...(idParaCrear ? { _id: idParaCrear } : {})
        });
      }

      if (response.status==200) {
        // Limpieza defensiva: tras un crear exitoso, descartar el id reservado
        // para que un nuevo formulario (si el componente sigue montado) reserve uno nuevo
        if (!esEdicion) {
          propuestaIdReservadoRef.current = null;
          setPropuestaIdReservado(null);
        }
        setMensaje({
          tipo: 'success',
          texto: esEdicion ? 'Propuesta actualizada correctamente' : 'Propuesta creada correctamente'
        });
        
        setTimeout(() => {
          navigate('/propuestas');
        }, 2000);
      } else {
        setMensaje({ tipo: 'danger', texto: response.message || 'Error al guardar propuesta' });
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error de conexión' });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // ==================== RENDER ====================

  if (loadingInicial) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">{esEdicion ? 'Cargando propuesta...' : 'Cargando datos iniciales...'}</p>
      </div>
    );
  }

  const totales = calcularTotalesGenerales();

  // ── Solicitudes de cambio del cliente ──────────────────────────────
  const SOLICITUD_CFG_EDITAR = {
    eliminar:           { bgPendiente: '#ffe0de', bgOtro: '#fff5f5', icon: 'bi-trash-fill',             colorHex: '#dc3545', label: 'Eliminar' },
    reducir_cantidad:   { bgPendiente: '#fff3cc', bgOtro: '#fffde7', icon: 'bi-arrow-down-circle-fill', colorHex: '#e08000', label: 'Reducir cant.' },
    solicitar_descuento:{ bgPendiente: '#cce5ff', bgOtro: '#e8f4ff', icon: 'bi-percent',               colorHex: '#0d6efd', label: 'Descuento' },
  };
  const haySolicitudes = esEdicion && Object.keys(solicitudesPorItemId).length > 0;
  const getItemIdStr = (item) => String(item?.item_id?._id || item?.item_id || '');
  const getSolicitudPorItem = (item) => { const k = getItemIdStr(item); return k ? solicitudesPorItemId[k] : undefined; };
  const isAtendida = (item) => solicitudesAtendidas.has(getItemIdStr(item));
  const toggleAtendida = (item) => {
    const key = getItemIdStr(item);
    setSolicitudesAtendidas(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };
  const getEstiloFilaEditar = (item) => {
    if (isAtendida(item)) return { backgroundColor: '#f0fff4' };
    const s = getSolicitudPorItem(item);
    if (!s) return {};
    const cfg = SOLICITUD_CFG_EDITAR[s.tipo_cambio];
    return cfg ? { backgroundColor: s.estado_solicitud === 'pendiente' ? cfg.bgPendiente : cfg.bgOtro } : {};
  };
  const renderCeldaSolicitud = (item) => {
    if (!haySolicitudes) return null;
    const s = getSolicitudPorItem(item);
    const atendida = isAtendida(item);
    if (!s) return <td style={{ width: '7%' }} />;
    const cfg = SOLICITUD_CFG_EDITAR[s.tipo_cambio];
    const tooltip = [
      cfg?.label,
      s.cantidad_sugerida ? `Nueva cant.: ${s.cantidad_sugerida}` : '',
      s.comentario_cliente ? `"${s.comentario_cliente}"` : '',
      s.estado_solicitud !== 'pendiente' ? `Estado: ${s.estado_solicitud}` : 'Pendiente',
    ].filter(Boolean).join(' | ');
    return (
      <td style={{ width: '7%', textAlign: 'center', verticalAlign: 'middle', padding: '2px 4px' }}>
        {!atendida && cfg && (
          <span title={tooltip} style={{
            display: 'inline-flex', alignItems: 'center', gap: '2px',
            fontSize: '0.62rem', fontWeight: 600, padding: '1px 4px',
            borderRadius: '4px', whiteSpace: 'nowrap',
            backgroundColor: cfg.colorHex, color: '#fff', cursor: 'help',
          }}>
            <i className={`bi ${cfg.icon}`} style={{ fontSize: '0.6rem' }} />{cfg.label}
          </span>
        )}
        <button type="button" title={atendida ? 'Desmarcar' : 'Marcar como atendido'} onClick={() => toggleAtendida(item)}
          style={{
            display: 'block', margin: '2px auto 0', border: 'none', borderRadius: '4px',
            cursor: 'pointer', fontSize: '0.6rem', padding: '1px 4px',
            backgroundColor: atendida ? '#198754' : '#dee2e6',
            color: atendida ? '#fff' : '#495057',
          }}>
          <i className={`bi ${atendida ? 'bi-check2-circle' : 'bi-check2'}`} /> {atendida ? 'Listo' : 'Listo'}
        </button>
      </td>
    );
  };
  // ────────────────────────────────────────────────────────────────────

    // Función para formatear número como moneda
    const formatearMoneda = (valor) => {
    if (!valor) return '';
    // Remover todo excepto números
    const numero = valor.toString().replace(/\D/g, '');
    // Formatear con separadores de miles
    return numero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    // Función para limpiar formato de moneda y obtener número
    const limpiarMoneda = (valorFormateado) => {
    if (!valorFormateado) return 0;
    return parseFloat(valorFormateado.toString().replace(/\./g, '')) || 0;
    };

  return (
    <div className="container-fluid py-4">
      {/* OVERLAY: Spinner pantalla completa al guardar */}
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.55)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999
        }}>
          <div className="text-center text-white">
            <Spinner animation="border" variant="light" style={{ width: '3.5rem', height: '3.5rem', borderWidth: '0.35em' }} />
            <p className="mt-3 fs-5 fw-semibold">
              {esEdicion ? 'Actualizando propuesta...' : 'Creando propuesta...'}
            </p>
          </div>
        </div>
      )}
      {/* Banner en verde para indicar si la propuesta ya esta sincronizada  */}
      {esEdicion && formData.sincronizada && (
        <Alert variant="success" className="mb-4 d-flex align-items-center">
          <i className="bi bi-check-circle-fill me-2"></i>
          La propuesta ya está sincronizada con el software contable.
        </Alert>
      )}


      <Card className='w-100'>
        <Card.Header className="bg-primary text-white w-100">
          <h5 className="mb-0">
            <i className="bi bi-file-earmark-text me-2"></i>
            {esEdicion ? 'Editar Propuesta Comercial' : 'Nueva Propuesta Comercial'}
          </h5>
        </Card.Header>
        <Card.Body className='w-100'>
          {mensaje.texto && (
            <Alert variant={mensaje.tipo} dismissible onClose={() => setMensaje({ tipo: '', texto: '' })}>
              {mensaje.texto}
            </Alert>
          )}

          {/* BANNER: PROVEEDOR CONTABLE */}
          {proveedorActivo === false && (
            <Alert variant="secondary" className="mb-3">
              <i className="bi bi-building me-2"></i>
              <strong>Sin proveedor contable activo:</strong> La propuesta se creará con la información de los ítems en la base de datos y los consecutivos de la plantilla. Para habilitar la integración contable, configure un proveedor en <strong>Configuración Contable</strong>.
            </Alert>
          )}
          {/* BANNER: CLIENTE SIN SINCRONIZADO */}
          {avisoClienteSync === 'no_sync' && (
            <Alert variant="warning" className="mb-3 d-flex justify-content-between align-items-center">
              <span>
                <i className="bi bi-person-exclamation me-2"></i>
                El cliente seleccionado no está sincronizado con el software contable. La propuesta se realiza pero no se podrá sincronizar con el proveedor contable hasta que se sincronice el cliente.
              </span>
              <Button
                size="sm"
                variant="warning"
                onClick={() => setModalSyncCliente({ show: true, cliente: clienteSeleccionadoData })}
              >
                <i className="bi bi-arrow-repeat me-1"></i>Sincronizar cliente
              </Button>
            </Alert>
          )}
          {avisoClienteSync === 'otro_proveedor' && (
            <Alert variant="warning" className="mb-3">
              <i className="bi bi-exclamation-triangle me-2"></i>
              El cliente está sincronizado con un proveedor contable diferente al activo actual.
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            {/* SECCIÓN: INFORMACIÓN DEL CLIENTE */}
            <h6 className="border-bottom pb-2 mb-3">Información del Cliente</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Cliente *</Form.Label>
                  <ClientSearchSelect
                    value={clienteOption}
                    onChange={handleClienteChange}
                    placeholder="Buscar cliente por nombre, NIT o ciudad..."
                    isClearable
                    menuPortalTarget={document.body}
                    isDisabled={esEdicion ? true : false}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label>Origen de la Solicitud *</Form.Label> 
                  <Form.Select
                    value={origenSolicitud.origen}
                    onChange={async (e) => {
                      const origen = e.target.value;
                      setOrigenSolicitud({ origen, evidenciaFile: '' });
                    }}
                    required
                  >
                    <option value="">-- Seleccione origen --</option>
                    <option value="Llamada">Llamada</option>
                    <option value="Redes sociales">Redes sociales</option>
                    <option value="Email">Email</option>
                    <option value="Visita Comercial">Visita Comercial</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
              {/*Obligatorio si se seleccionan 'Redes sociales' o 'Email' */}
                {['Redes sociales', 'Email'].includes(origenSolicitud.origen) && (
                    
                    <Form.Group className="mb-2">
                      <Form.Label>Adjuntar evidencia *</Form.Label> 
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf"
                          disabled={subiendoEvidencia}
                          onChange={async (e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;
                            setSubiendoEvidencia(true);
                            try {
                              const idPropuesta = await asegurarIdReservado();
                              const res = await subirArchivoPropuesta(idPropuesta, 'origen', file);
                              const url = res.data?.url;
                              if (url) setOrigenSolicitud(prev => ({ ...prev, evidenciaFile: url }));
                            } catch { setMensaje({ tipo: 'danger', texto: 'Error al subir evidencia' }); }
                            setSubiendoEvidencia(false);
                            e.target.value = '';
                          }}
                        />
                        {subiendoEvidencia && <Spinner animation="border" size="sm" className="mt-1" />}
                        {origenSolicitud.evidenciaFile && (
                          <a href={origenSolicitud.evidenciaFile} target="_blank" rel="noreferrer" className="d-block small mt-1">
                            <i className="bi bi-check-circle-fill text-success me-1"></i>Evidencia adjuntada
                          </a>
                        )}
                        {!origenSolicitud.evidenciaFile && !subiendoEvidencia && (
                          <Form.Text className="text-muted">Adjunte captura de pantalla o correo (requerido)</Form.Text>
                        )}
                  </Form.Group>
                  )}

              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha Propuesta *</Form.Label>
                  <Form.Control
                    type="date"
                    name="fecha_propuesta"
                    value={formData.fecha_propuesta}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Vigencia Hasta *</Form.Label>
                  <Form.Control
                    type="date"
                    name="fecha_vigencia"
                    value={formData.fecha_vigencia}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              {/* BOTONES */}
              <Col md={6}>
              <div className="d-flex gap-2 mt-4">
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => navigate('/propuestas')}
                >
                  <i className="bi bi-x-circle me-2"></i>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  disabled={loading || loadingInicial}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Guardando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-save me-2"></i>
                      {esEdicion ? 'Actualizar Propuesta' : 'Crear Propuesta'}
                    </>
                  )}
                </Button>

              </div>
              </Col>
              {/* TIPO DE EDICIÓN + EVIDENCIA + MOTIVO (solo en edición) */}
              {esEdicion && (
              <>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo de edición <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      value={tipoEdicion}
                      onChange={(e) => {
                        const t = e.target.value;
                        setTipoEdicion(t);
                        if (t === 'cliente' && !motivoCambio) {
                          setMotivoCambio('Actualización solicitada por el cliente');
                        }
                        if (t === 'interna') setEvidenciaCambio('');
                      }}
                    >
                      <option value="cliente">Solicitada por el cliente</option>
                      <option value="interna" disabled={formData.estado !== 'borrador'}>
                        Actualización interna{formData.estado !== 'borrador' ? ' (solo en borrador)' : ''}
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                {tipoEdicion === 'cliente' && (
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Evidencia (foto/PDF) <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        disabled={subiendoEvidenciaCambio}
                        onChange={async (e) => {
                          const f = e.target.files?.[0];
                          if (!f) return;
                          setSubiendoEvidenciaCambio(true);
                          try {
                            const res = await subirArchivoPropuesta(id, 'evidencias-cambio', f);
                            if (res.data?.url) setEvidenciaCambio(res.data.url);
                          } catch {
                            setMensaje({ tipo: 'danger', texto: 'Error al subir evidencia' });
                          }
                          setSubiendoEvidenciaCambio(false);
                          e.target.value = '';
                        }}
                      />
                      {subiendoEvidenciaCambio && <Spinner animation="border" size="sm" className="mt-1" />}
                      {evidenciaCambio && (
                        <small className="d-block mt-1 text-success">
                          <i className="bi bi-check-circle-fill me-1"></i>Evidencia adjuntada
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                )}

                <Col md={tipoEdicion === 'cliente' ? 4 : 8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Motivo del cambio <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={motivoCambio}
                      onChange={e => { setMotivoCambio(e.target.value); setErrorMotivo(''); }}
                      placeholder={tipoEdicion === 'cliente'
                        ? 'Actualización solicitada por el cliente'
                        : 'Describa el cambio interno...'}
                      isInvalid={!!errorMotivo}
                    />
                    <Form.Control.Feedback type="invalid">{errorMotivo}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </>
              )}

            </Row>
            {/* SECCIÓN: ÍTEMS */}
            <h6 className="border-bottom pb-2 mb-3 mt-4">Ítems de la Propuesta</h6>
            <div className="table-responsive">
              <Table bordered hover size="sm">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '4%' }}>#</th>
                    {haySolicitudes && <th style={{ width: '7%', fontSize: '0.75rem' }} title="Solicitudes del cliente">Sol.</th>}
                    <th style={{ width: '14%' }}>Código *</th>
                    <th style={{ width: '12%' }}>Nombre del Producto</th>
                    <th style={{ width: '18%' }}>Descripción</th>
                    <th style={{ width: '7%' }}>Cant. *</th>
                    <th style={{ width: '11%' }}>Valor Unit. *</th>
                    <th style={{ width: '10%' }}>IVA %</th>
                    <th style={{ width: '6%' }}>Dto. %</th>
                    <th style={{ width: '10%' }}>Total</th>
                    <th style={{ width: '4%' }} className="text-center">
                      <i className="bi bi-trash"></i>
                    </th>
                    {proveedorActivo && <th style={{ width: '4%' }} className="text-center" title="Estado contable"><i className="bi bi-building"></i></th>}
                  </tr>
                </thead>
                <tbody>
                  {itemsPropuesta.map((item, index) => {
                    const itemSeleccionado = item.item_id
                      ? itemsDisponibles.find(opt => String(opt.value) === String(item.item_id))
                      : null;
                    return (
                      <tr key={item.id_temporal} style={getEstiloFilaEditar(item)}>
                        {/* # */}
                        <td className="text-center align-middle">
                          {item.item_id ? index + 1 : ''}
                        </td>
                        {/* Columna solicitud cliente */}
                        {renderCeldaSolicitud(item)}

                        {/* CÓDIGO - Selector reutilizable con búsqueda en BD */}
                        <td className="align-top" style={{ height: '100%' }}>
                          <div
                            title={itemSeleccionado?.label || 'Seleccione un producto para autocompletar los campos'}
                            style={{ height: '100%', minHeight: '32px' }}
                          >
                            <ItemSearchSelect
                              mode="async"
                              value={itemSeleccionado || null}
                              onChange={(selected) => handleItemSelect(index, selected)}
                              searchMinChars={3}
                              disabledIds={itemsPropuesta
                                .filter((fila, i) => i !== index && fila.item_id)
                                .map((fila) => String(fila.item_id))}
                              placeholder="Buscar..."
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              isClearable
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  height: '100%',
                                }),
                                control: (base) => ({
                                  ...base,
                                  minHeight: '32px',
                                  height: '100%',
                                  fontSize: '0.875rem'
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  padding: '0 6px'
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: '0px',
                                }),
                                menu: (base) => ({
                                  ...base,
                                  width: 'max-content',
                                  minWidth: '100%',
                                  zIndex: 9999
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                })
                              }}
                            />
                          </div>
                        </td>

                        {/* NOMBRE */}
                        <td>
                          <Form.Control 
                            as="textarea"
                            size="sm"
                            value={item.nombre}
                            onChange={(e) => handleCambiarCampoItem(index, 'nombre', e.target.value)}
                            placeholder="Nombre del producto"
                            disabled={!item.item_id}
                            className="border-0"
                          />
                        </td>

                        {/* DESCRIPCIÓN */}
                        <td>
                          {/**Si el texto es muy grande que coloque un textarea con scroll rows={3} maxRows={6} */}
                          <Form.Control
                            as="textarea"
                            maxRows={6}
                            size="sm"
                            value={item.descripcion}
                            onChange={(e) => handleCambiarCampoItem(index, 'descripcion', e.target.value)}
                            placeholder="Descripción"
                            disabled={!item.item_id}
                            className="border-0"
                          />
                        </td>

                        {/* CANTIDAD */}
                        <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            min="1"
                            step="1"
                            value={item.cantidad}
                            onChange={(e) => handleCambiarCampoItem(index, 'cantidad', e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            disabled={!item.item_id}
                            className="border-0 text-center no-arrows"
                        />
                        </td>

                        {/* VALOR UNITARIO */}
                        <td>
                        <Form.Control
                            type="text"
                            size="sm"
                            value={item.item_id ? formatearMoneda(item.valor_unitario) : ''}
                            onChange={(e) => handleCambiarCampoItem(index, 'valor_unitario', e.target.value)}
                            disabled={!item.item_id}
                            className="border-0 text-end no-arrows"
                            placeholder="0"
                            onFocus={(e) => {
                            // Limpiar formato al hacer foco para facilitar edición
                            if (item.valor_unitario) {
                                e.target.value = item.valor_unitario.toString();
                            }
                            }}
                            onBlur={(e) => {
                            // Reformatear al perder el foco
                            if (e.target.value) {
                                const valorLimpio = limpiarMoneda(e.target.value);
                                handleCambiarCampoItem(index, 'valor_unitario', valorLimpio);
                            }
                            }}
                        />
                        </td>

                        {/* IVA %  en este input va un select con el listado de impuesto almacenados en taxes*/}
                        <td>
                        <Form.Select
                            size="sm"
                            value={item.porcentaje_iva}
                            onChange={(e) => handleSeleccionarTax(
                              index, taxes.find(
                                t => t.porcentaje === parseFloat(e.target.value))
                              )}

                            disabled={!item.item_id}
                        >
                            {taxes.map((tax) => (
                                <option key={tax.id} value={tax.porcentaje}>
                                    {tax.porcentaje}%
                                </option>
                            ))}
                        </Form.Select>

                        </td>
                        {/* DESCUENTO % */}
                        <td>
                        <Form.Control
                            type="number"
                            size="sm"
                            min="0"
                            max="100"
                            step="1"
                            value={item.taxDescuento ?? 0}
                            onChange={(e) => handleCambiarCampoItem(index, 'taxDescuento', e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            disabled={!item.item_id}
                            className="border-0 text-center no-arrows"
                        />
                        </td>
                        {/* TOTAL */}
                        <td className="text-end align-middle fw-bold">
                          {item.item_id ? `$${item.total.toLocaleString('es-CO', { minimumFractionDigits: 2 })}` : ''}
                        </td>

                        {/* ELIMINAR */}
                        <td className="text-center align-middle">
                          {item.item_id && (
                            <Button
                              variant="link"
                              size="sm"
                              className="text-danger p-0"
                              onClick={() => handleEliminarItem(index)}
                              title="Eliminar ítem"
                            >
                              <i className="bi bi-trash"></i>
                            </Button>
                          )}
                        </td>
                        {/* CONTABILIDAD SINCRONIZADO */}
                        {proveedorActivo && (
                          <td className="text-center align-middle" style={{ padding: '2px 4px' }}>
                            {item?.item_id && (() => {
                              const sincronizado = itemEstaSincronizado(item.item_id);
                              return sincronizado ? (
                                <span title="Sincronizado con software contable" style={{ color: '#198754', fontSize: '0.85rem' }}>
                                  <i className="bi bi-check-circle-fill"></i>
                                </span>
                              ) : (
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0"
                                  title="No sincronizado — clic para vincular"
                                  onClick={() => setModalSyncItem({ show: true, item: item._itemData || { _id: item.item_id, nombre: item.nombre } })}
                                >
                                  <Badge bg="warning" text="dark" style={{ fontSize: '0.65rem', cursor: 'pointer' }}>
                                    <i className="bi bi-exclamation-triangle-fill me-1"></i>Sync
                                  </Badge>
                                </Button>
                              );
                            })()}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            {totales.cantidad_items === 0 && (
              <Alert variant="info" className="mt-2">
                <i className="bi bi-info-circle me-2"></i>
                Seleccione productos usando el dropdown en la columna "Código"
              </Alert>
            )}

            {/* SECCIÓN: RESUMEN DE TOTALES */}
            {totales.cantidad_items > 0 && (
              <Card className="mt-4 border-0 shadow-sm w-100">
                <Card.Body className='w-100'>
                  <Row>
                    {/* DESCUENTO GLOBAL */}
                    <Col md={6}>
                      <h6 className="mb-3">Descuento Global (Opcional)</h6>
                      <Form.Group className="mb-3" style={{ maxWidth: '200px' }}>
                        <Form.Label>Porcentaje de Descuento</Form.Label>
                        <Form.Control
                          type="number"
                          size="sm"
                          min="0"
                          max="100"
                          step="0.01"
                          value={descuentoGlobal}
                          onChange={(e) => handleCambiarDescuentoGlobal(e.target.value)}
                          onWheel={(e) => e.target.blur()}
                          placeholder="0"
                          className="no-arrows"
                        />
                        <Form.Text className="text-muted">Se aplica a todos los ítems</Form.Text>
                      </Form.Group>
                    </Col>

                    {/* TOTALES */}
                    <Col md={6}>
                      <h6 className="mb-3">Resumen Financiero</h6>
                      <Table bordered size="sm" className="mb-0">
                        <tbody>
                          <tr>
                            <td className="text-end fw-bold">Total Bruto:</td>
                            <td className="text-end" style={{ width: '150px' }}>
                              ${totales.total_bruto.toLocaleString('es-CO', { minimumFractionDigits: 2 })}
                            </td>
                          </tr>
                          {totales.total_bruto > totales.subtotal && (
                            <tr className="table-warning">
                              <td className="text-end fw-bold">Descuento:</td>
                              <td className="text-end">
                                -${(totales.total_bruto - totales.subtotal).toLocaleString('es-CO', { minimumFractionDigits: 2 })}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td className="text-end fw-bold">Subtotal:</td>
                            <td className="text-end">
                              ${totales.subtotal.toLocaleString('es-CO', { minimumFractionDigits: 2 })}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end fw-bold">IVA:</td>
                            <td className="text-end">
                              ${totales.total_iva.toLocaleString('es-CO', { minimumFractionDigits: 2 })}
                            </td>
                          </tr>
                          <tr className="table-primary">
                            <td className="text-end fw-bold fs-6">TOTAL A PAGAR:</td>
                            <td className="text-end fw-bold fs-5">
                              ${totales.total_pagar.toLocaleString('es-CO', { minimumFractionDigits: 2 })}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}

            {/* SECCIÓN: CONDICIONES COMERCIALES */}
            <h6 className="border-bottom pb-2 mb-3 mt-4">Condiciones Comerciales</h6>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Condiciones de Pago</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="condiciones_pago"
                    value={formData.condiciones_pago}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Observaciones</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="observaciones"
                    value={formData.observaciones}
                    onChange={handleChange}
                    disabled={true}
                    placeholder="Observaciones adicionales..."
                    // condicion por cantidad de texto, si no hay texto el textarea se ve muy pequeño, entonces se le da un tamaño minimo pero que pueda crecer segun la cantidad de texto que haya
                    style={{ minHeight: '200px', resize: 'vertical' }}  // el tamaño depende de la cantidad de texto, pero se le da un mínimo para que no se vea tan pequeño
                  />
                </Form.Group>
              </Col>
              {/* Documentos adjuntos mostrar los que estan en formData.fileDownload con título y opcion de descargar o ver en nueva ventana  */}
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Documentos Adjuntos</Form.Label>
                           {formData?.fileDownload?.length === 0 ? (
                                  <p className="text-muted small mb-0">Sin archivos adjuntos.</p>
                                ) : (
                                  <ListGroup variant="flush">
                                    {formData.fileDownload?.map((url, idx) => {
                                      const nombre = extraerNombreArchivo(url) || `Adjunto ${idx + 1}`;
                                      return (
                                        <ListGroup.Item key={idx} className="d-flex align-items-center justify-content-between px-0">
                                          <a href={url} target="_blank" rel="noreferrer" className="text-truncate me-2" style={{ maxWidth: '75%' }}>
                                            <i className="bi bi-file-earmark me-1"></i>{nombre}
                                          </a>
                                        </ListGroup.Item>
                                      );
                                    })}
                                  </ListGroup>
                                )}
                </Form.Group>
              </Col>
            </Row>




          </Form>
        </Card.Body>
      </Card>

      {/* MODAL: Sincronizar cliente con software contable */}
      <ClienteModal
        show={modalSyncCliente.show}
        onHide={() => setModalSyncCliente({ show: false, cliente: null })}
        usuario={modalSyncCliente.cliente}
        onSave={handleSaveCliente}
      />

      {/* MODAL: Sincronizar ítem con software contable */}
      <EditarItem
        show={modalSyncItem.show}
        onHide={() => setModalSyncItem({ show: false, item: null })}
        item={modalSyncItem.item}
        hayProveedor={!!proveedorActivo}

        onSaved={async () => {
          // Recargar la lista de ítems disponibles para reflejar el nuevo estado de sincronización
          try {
            const itemsRes = await getDataList('Items'); // Traer todos los ítems para tener la información actualizada, incluyendo datos de contabilidad
            
            if (itemsRes.status === 200 && itemsRes.data.data) {
              const itemsFormateados = itemsRes.data.data.map(i => ({
                value: i._id,
                label: `${i.nombre}`,
                codigo: i.codigo,
                data: i
              }));

              setItemsDisponibles(itemsFormateados);  // Actualizar opciones del selector de ítems con la información más reciente

              // Actualizar _itemData y campos visibles en filas ya seleccionadas

              setItemsPropuesta(prev => prev.map(fila => { // Solo actualizar filas que tengan un item_id y que coincida con el ítem actualizado
                if (!fila.item_id) return fila;
                const itemActualizado = itemsRes.data.data.find(i => String(i._id) === String(fila.item_id));
                if (!itemActualizado) return fila;

                const contab = itemActualizado.contabilidad; // Información de sincronización contable del ítem actualizado

                const sincronizado = proveedorActivo &&
                  contab?.providerId === String(proveedorActivo._id) && !!contab?.id;


                const filaActualizada = { // Mantener toda la información de la fila, pero actualizar _itemData y campos visibles según el nuevo estado del ítem
                  ...fila,
                  _itemData: itemActualizado,
                  nombre: (sincronizado && contab?.name) ? contab.name : fila.nombre,
                  descripcion: (sincronizado && contab?.description) ? contab.description : fila.descripcion,
                  itemIdContable: sincronizado ? contab.id : fila.itemIdContable,
                  valor_unitario: (sincronizado && contab?.priceLists?.[0]?.price)
                    ? contab.priceLists[0].price
                    : fila.valor_unitario,
                };

                return calcularTotalesItem(filaActualizada);
              }));
            }
          } catch (e) {
            console.error('Error al recargar ítems:', e);
          }
          setModalSyncItem({ show: false, item: null });
        }}


      />
    </div>
  );
};

export default CrearPropuesta;